import { graphql, useStaticQuery } from 'gatsby'

export default function useDocumentCountry() {
	const result = useStaticQuery(
		graphql`
			query IDENTIFICATION_DOCUMENT_WEBINAR {
				allContentfulTenaRegistroV2(
					filter: { slug: { eq: "informacion-personal" } }
				) {
					nodes {
						node_locale
						inputNumeroDeDocumento
						inputTipoDeDocumento
						tipoDeDocumento {
							name
							value
						}
					}
				}
			}
		`
	)

	const countries = [
		{
			name: 'COLOMBIA',
			value: 'es-CO',
			locale: 'es-CO',
			prefix: '+57',
			code: 1,
			cellDig: 10,
		},
		{
			name: 'ARGENTINA',
			value: 'es-AR',
			locale: 'es-AR',
			prefix: '+54',
			code: 9,
			cellDig: 10,
		},
		{
			name: 'BOLIVIA',
			value: 'es-BO',
			locale: 'es-BO',
			prefix: '+591',
			code: 7,
			cellDig: 8,
		},
		{
			name: 'REPÚBLICA DOMINICANA',
			value: 'es-DO',
			locale: 'es-DO',
			prefix: '+1',
			code: 13,
			cellDig: 10,
		},
		{
			name: 'ECUADOR',
			value: 'es-EC',
			locale: 'es-EC',
			prefix: '+593',
			code: 5,
			cellDig: 10,
		},
		{
			name: 'PERÚ',
			value: 'es-PE',
			locale: 'es-PE',
			prefix: '+51',
			code: 6,
			cellDig: 9,
		},
		{
			name: 'PUERTO RICO',
			value: 'es-PR',
			locale: 'es-PR',
			prefix: '+1',
			code: 12,
			cellDig: 10,
		},
		{
			name: 'CHILE',
			value: 'es-CL',
			locale: 'es-CL',
			prefix: '+56',
			code: 8,
			cellDig: 9,
		},
	]

	const removePrefix = cellPhone => {
		let cellPhoneNoPrefix = cellPhone
		countries.forEach(country => {
			if (cellPhone.includes(country.prefix)) {
				cellPhoneNoPrefix = cellPhone.replace(country.prefix, '')
			}
		})
		return cellPhoneNoPrefix
	}

	const filterDocumentsType = country =>
		result.allContentfulTenaRegistroV2.nodes.filter(e =>
			e.node_locale
				.toLowerCase()
				.includes(
					country?.toLowerCase() || process.env.LOCALE?.toLowerCase() || 'es-co'
				)
		)[0]

	const getCountryByCode = code =>
		countries.filter(
			country => country.code === (code || parseInt(process.env.COUNTRY_CODE))
		)[0]

	return { countries, filterDocumentsType, getCountryByCode, removePrefix }
}
